import { Trans } from '@lingui/react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { putCollectiveOrderAction } from 'shared/store/ducks/cart'
import { type IState } from 'types/redux/store'
import InputCheckbox from 'views/components/molecules/InputCheckbox'
import { COLLECTIVE_ORDER_MODAL } from 'views/components/organisms/Cart/CollectiveOrderModal/const'
import { useMaxDosageValues } from 'views/components/organisms/Cart/hooks/useMaxDosageValues'

const CollectiveOrderBox = () => {
  const dispatch = useDispatch()

  const isCollectiveOrderStatus = useSelector(
    (state: IState) => state.cart.data?.collectiveOrder
  )

  const { hasOverdrafts, isForMaxDosageLoggedInUser, maxDosageDetails } =
    useMaxDosageValues()

  useEffect(() => {
    if (isForMaxDosageLoggedInUser && hasOverdrafts && maxDosageDetails) {
      dispatch(putCollectiveOrderAction(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <span className="l-flex l-flex--start u-padding--top">
      <InputCheckbox
        onClick={() => {
          dispatch(putCollectiveOrderAction(!isCollectiveOrderStatus))
        }}
        checked={isCollectiveOrderStatus}
        id="multiorder-cart-sum-box"
        name="cart-sumBox-multiorder-input"
      >
        {''}
      </InputCheckbox>
      <p className="u-no-margin--bottom o-CartSumBox__CollectiveOrderBox__text">
        <Trans id="cart.label.orderMultiplePerson" />
        <u
          data-a11y-dialog-show={COLLECTIVE_ORDER_MODAL}
          className="u-margin-xx-small--left o-CartSumBox__CollectiveOrderBox__link"
          style={{ cursor: 'pointer' }}
        >
          <Trans id="general.more.information.short" />
        </u>
      </p>
    </span>
  )
}

export default CollectiveOrderBox
